<ng-template #dmModalWrapper>
    <div class="modal-header">
        <b class="modal-title pull-left">{{ title }}</b>
        <div class="pull-right">
            <dm-toolbar [buttons]="headerButtons"></dm-toolbar>
        </div>
    </div>
    <div class="modal-body">
        <ng-content></ng-content>
    </div>
    <div class="modal-footer" *ngIf="!!footerButtons.length">
        <dm-toolbar [buttons]="footerButtons"></dm-toolbar>
    </div>
</ng-template>
